/** Tema do painel: segue o sistema por padrão; a escolha manual fica neste navegador. */
export type Theme = 'system' | 'light' | 'dark';
const KEY = 'dnx:theme';

export function getTheme(): Theme {
  try {
    const t = localStorage.getItem(KEY);
    return t === 'light' || t === 'dark' ? t : 'system';
  } catch {
    return 'system';
  }
}

export function applyTheme(t: Theme): void {
  const root = document.documentElement;
  if (t === 'system') delete root.dataset.theme;
  else root.dataset.theme = t;
}

export function setTheme(t: Theme): void {
  try {
    if (t === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, t);
  } catch { /* navegação privada: vale só nesta aba */ }
  applyTheme(t);
}
